/* Sensefuel doc: 
 *  - add to cart: https://helpdesk.sensefuel.com/hc/en-us/articles/17789697080220-Add-to-cart
*/

window.pkSensefuelHandleTriggerCart = function() {
  const miniCart = document.getElementById('mini-cart');
  
  if (miniCart) {
    miniCart.open = true;
  } else {
    window.location.href = `${window.location.origin}/cart`;
  }
};

window.pkSensefuelGetCart = async function() {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();

    const articles = {};

    for (const item of data.items) {
      articles[item.variant_id] = {
        quantity: item.quantity,
        loose: false
      };
    }

    return { articles };
  } catch (err) {
    console.error('[Sensefuel getCart] Error :', err);
    return { articles: {} };
  }
};

window.pkSensefuelAddToCart = async function(id, quantity, loose = false) {
  let items = [{ id: id, quantity: quantity }];
  
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items[0])
    });

    window.sensefuelDatalayer = window.sensefuelDatalayer || {};
    window.sensefuelDatalayer.articles = window.sensefuelDatalayer.articles || {};
    window.sensefuelDatalayer.articles[id] = { quantity, loose };

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    window.pkSensefuelHandleTriggerCart?.();

    return 'success';
  } catch (err) {
    console.error('[Sensefuel addToCart] Error :', err);
    return 'error';
  }
};
